const GET_RESERVATION = 'autohost/guestportal/GET_RESERVATION';
const GET_RESERVATION_SUCCESS = 'autohost/guestportal/GET_RESERVATION_SUCCESS';
const GET_RESERVATION_FAIL = 'autohost/guestportal/GET_RESERVATION_FAIL';
const GET_CHECKIN_DETAILS = 'autohost/guestportal/GET_CHECKIN_DETAILS';
const GET_CHECKIN_DETAILS_SUCCESS = 'autohost/guestportal/GET_CHECKIN_DETAILS_SUCCESS';
const GET_CHECKIN_DETAILS_FAIL = 'autohost/guestportal/GET_CHECKIN_DETAILS_FAIL';
const PING_START = 'autohost/guestportal/PING_START';
const PING_START_SUCCESS = 'autohost/guestportal/PING_START_SUCCESS';
const PING_START_FAIL = 'autohost/guestportal/PING_START_FAIL';
const SAVE_PROGRESS = 'autohost/guestportal/SAVE_PROGRESS';
const SAVE_PROGRESS_SUCCESS = 'autohost/guestportal/SAVE_PROGRESS_SUCCESS';
const SAVE_PROGRESS_FAIL = 'autohost/guestportal/SAVE_PROGRESS_FAIL';
const UPLOAD_PHOTO = 'autohost/guestportal/UPLOAD_PHOTO';
const UPLOAD_PHOTO_SUCCESS = 'autohost/guestportal/UPLOAD_PHOTO_SUCCESS';
const UPLOAD_PHOTO_FAIL = 'autohost/guestportal/UPLOAD_PHOTO_FAIL';
const STRIPE_SEND = 'autohost/guestportal/STRIPE_SEND';
const STRIPE_SEND_SUCCESS = 'autohost/guestportal/STRIPE_SEND_SUCCESS';
const STRIPE_SEND_FAIL = 'autohost/guestportal/STRIPE_SEND_FAIL';
const SUBMIT_FORM = 'autohost/guestportal/SUBMIT_FORM';
const SUBMIT_FORM_SUCCESS = 'autohost/guestportal/SUBMIT_FORM_SUCCESS';
const SUBMIT_FORM_FAIL = 'autohost/guestportal/SUBMIT_FORM_FAIL';
const SET_OVERLAY_FORM = 'autohost/guestportal/SET_OVERLAY_FORM';

const initialState = {
    loading: false,
    loaded: false,
    reservation: null,
    checkin: null,
    error: null,
    overlay: null,
    country: null,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_RESERVATION:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_RESERVATION_SUCCESS:
            // // always update (even if score goes down)
            // return {
            //     ...state,
            //     loading: false,
            //     loaded: true,
            //     reservation: action.payload
            // }
            // Only update if score goes up
            const newScore = action.payload.protect_score;
            const oldScore = state.reservation && state.reservation.protect_score;
            if (!oldScore || (oldScore && newScore && oldScore < newScore)) {
                return {
                    ...state,
                    loading: false,
                    loaded: true,
                    reservation: action.payload,
                    error: null,
                }
            }
            return {
                ...state,
                loading: false,
                loaded: true,
                error: null,
            };
        case GET_RESERVATION_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            };
        case PING_START_SUCCESS:
            return {
                ...state,
                country: action.payload.ip_country,
                timezone: action.payload.ip_timezone
            };
        case SUBMIT_FORM:
            return state;
        case SUBMIT_FORM_SUCCESS:
            return state;
        case SUBMIT_FORM_FAIL:
            return {
                ...state,
                error: action.error
            };
        case SET_OVERLAY_FORM:
            return {
                ...state,
                overlay: action.overlay
            };
        default:
            return state;
    }
}

export function getReservation(id, options = {}) {
    const query = Object.keys(options).map(k => `${k}=${options[k]}`).join('&');
    return {
        types: [GET_RESERVATION, GET_RESERVATION_SUCCESS, GET_RESERVATION_FAIL],
        id: id,
        promise: (client) => client.get(`/guestportal/reservation/${id}?${query}`)
    };
}

export function getCheckin(id) {
    return {
        types: [GET_CHECKIN_DETAILS, GET_CHECKIN_DETAILS_SUCCESS, GET_CHECKIN_DETAILS_FAIL],
        id: id,
        promise: (client) => client.get(`/guestportal/checkin/${id}`)
    };
}

export function pingStart(id) {
    const fp = global.__ahpfp;
    const session = global.__ahpfppro;
    return {
        types: [PING_START, PING_START_SUCCESS, PING_START_FAIL],
        id: id,
        promise: (client) => client.get(`/guestportal/pingstart/${id}${fp ? `?version=${fp}&session=${session}` : ''}`)
    };
}

export function sendStripeToken(id, data) {
    return {
        types: [STRIPE_SEND, STRIPE_SEND_SUCCESS, STRIPE_SEND_FAIL],
        id: id,
        promise: (client) => client.post(`/guestportal/stripe/${id}`, {data})
    };
}

export function sendChargeRequest(id, data) {
    return {
        types: [STRIPE_SEND, STRIPE_SEND_SUCCESS, STRIPE_SEND_FAIL],
        id: id,
        promise: (client) => client.post(`/guestportal/extraCharges/${id}`, {data})
    };
}

export function submitForm(reservationId, data, query = {}) {
    const queryString = Object.keys(query).map(k => `${k}=${query[k]}`).join('&');
    return {
        types: [SUBMIT_FORM, SUBMIT_FORM_SUCCESS, SUBMIT_FORM_FAIL],
        promise: (client) => client.post(`/guestportal/finished/${reservationId}?${queryString}`, {data})
    };
}

export function saveProgress(reservationId, lastStep, data) {
    return {
        types: [SAVE_PROGRESS, SAVE_PROGRESS_SUCCESS, SAVE_PROGRESS_FAIL],
        promise: (client) => client.post(`/guestportal/saveProgress/${reservationId}?last_step=${lastStep}`, {data})
    };
}

export function uploadPhoto(reservationId, imageType, b64Image, query) {
    const q = query ? `?${Object.keys(query).map(k => `${k}=${query[k]}`).join('&')}` : '';
    return {
        types: [UPLOAD_PHOTO, UPLOAD_PHOTO_SUCCESS, UPLOAD_PHOTO_FAIL],
        promise: (client) => client.post(`/guestportal/uploadPhoto/${reservationId}${q}`, {data: {type: imageType, image: b64Image}})
    };
}

export function setOverlayForm(overlay) {
    return {
        type: SET_OVERLAY_FORM,
        overlay
    }
}